import { render, staticRenderFns } from "./tenant-keys.vue?vue&type=template&id=18433713&scoped=true&"
import script from "./tenant-keys.ts?vue&type=script&lang=ts&"
export * from "./tenant-keys.ts?vue&type=script&lang=ts&"
import style0 from "./tenant-keys.scss?vue&type=style&index=0&id=18433713&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18433713",
  null
  
)

export default component.exports